import { platformPageHead } from "../platform/head";
import { isPlatformShell, type PlatformShell } from "../platform/shell";
import type { SiteShell } from "../server/shell";
import { creatorPageHead } from "./head";

type Shell = SiteShell | PlatformShell | undefined;

function stateHead(shell: Shell, page: { pathname: string; title: string; description: string }) {
  const name = isPlatformShell(shell) ? "Drate" : shell?.creator.name || "Drate";
  const head = { ...page, title: `${page.title} | ${name}`, noindex: true };
  return isPlatformShell(shell) ? platformPageHead(shell, head) : creatorPageHead(shell, head);
}

/**
 * The head of a page that doesn't exist: its title, description and noindex,
 * described at /404 as the Astro site rewrote it.
 */
export function notFoundHead(shell: Shell) {
  return stateHead(shell, {
    pathname: "/404",
    title: "Page not found",
    description: "This page could not be found.",
  });
}

/** The head of a page that failed to render. */
export function errorHead(shell: Shell) {
  return stateHead(shell, {
    pathname: "/500",
    title: "Something went wrong",
    description: "This page could not be loaded right now.",
  });
}
